import {
	Component,
	input,
	output,
	ChangeDetectionStrategy,
} from '@angular/core'
import { BaseAction } from '../../models/base-action.model'

@Component({
	selector: 'lowgile-results-list',
	templateUrl: './results-list.component.html',
	styleUrls: ['./results-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ResultsListComponent {
	actions = input<BaseAction[]>([])
	activeIndex = input<number>(0)
	query = input<string>('')
	actionSelect = output<BaseAction>()

	onActionSelect(action: BaseAction): void {
		this.actionSelect.emit(action)
	}
}
